import { inactiveFusesService } from "../../_services";
import { inactiveFusesContants } from "../_redux-constants";

function getInactiveFuses(queryParams) {
  function getInactiveFusesLoad() {
    return {
      type: inactiveFusesContants.INACTIVE_FUSES_LOADING,
    };
  }
  function InactiveFusesSuccess(data) {
    return {
      type: inactiveFusesContants.INACTIVE_FUSES_SUCCESS,
      data,
    };
  }
  function InactiveFusesFailure(error) {
    return {
      type: inactiveFusesContants.INACTIVE_FUSES_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getInactiveFusesLoad());
    inactiveFusesService.getInactiveFuses(queryParams).then(
      (data) => {
        dispatch(InactiveFusesSuccess(data));
      },
      (error) => {
        dispatch(InactiveFusesFailure(error?.toString()));
      }
    );
  };
}

export const inactiveFusesActions = {
  getInactiveFuses,
};
